import bridge from './bridge'
import { params } from '@didi/driver-biz-sdk'
import { env } from '@didi/utils'

export function backButtonCloseAll():void {
  if (params.urlParams.close === 'true') {
    driverAppHandler()
    rainbowAppHandler()
  }
}

function driverAppHandler() {
  if (env.isDriver) {
    bridge.controlBackPress({
      type: 'request'
    }, () => {
      bridge.closePage()
    })
  }
}

function rainbowAppHandler() {
  if (env.rainbow) {
    bridge.closePage()
  }
}
